import colorSharp from "../assets/img/color-sharp.png";
import "./Certifications.css";

const certifications = [
  {
    name: "Microsoft Azure Fundamentals",
    code: "AZ-900",
    issuer: "Microsoft",
    date: "Sep 2026", // Update with your actual date
    // credentialId: "3E14CA217AFD304C", // Add your credential ID if you have one
    verifyUrl: "https://learn.microsoft.com/api/credentials/share/en-us/KaveeshaDhanasekara/3E14CA217AFD304C?sharingId=3C747FBCEB2C4D1D", // Add your verification URL if you have one
    badge:
      "https://learn.microsoft.com/media/learn/certification/badges/microsoft-certified-fundamentals-badge.svg",
  },
  
  {
    name: "AWS Educate Getting Started with Serverless",
    code: "",
    issuer: "Amazon Web Services (AWS)",
    date: "Jun 2026",
    // credentialId: "04ffb905-cd92-43af-91dc-60ac9cf8114d",
    verifyUrl: "https://www.credly.com/badges/d561553f-0e1f-4c72-aea9-7b2605387989/public_url",
    badge: "https://images.credly.com/size/680x680/images/25108813-2dd7-45f7-8158-65689b8526b5/blob",
  },
  
  {
    name: "[NEW] Ultimate AWS Certified Cloud Practitioner CLF-C02 2026",
    code: "",
    issuer: "Udemy",
    date: "Dec 2025",
    // credentialId: "UC-8978c621-516e-49b2-980e-de5ee711301f",
    verifyUrl: "https://www.udemy.com/certificate/UC-8978c621-516e-49b2-980e-de5ee711301f/",
    badge: "https://udemy-certificate.s3.amazonaws.com/image/UC-8978c621-516e-49b2-980e-de5ee711301f.jpg?v=1766549138000",
  },
  {
    name: "100 Days of DevOps",
    code: "",
    issuer: "KodeKloud",
    date: "Jun 2026",
    // credentialId: "04ffb905-cd92-43af-91dc-60ac9cf8114d",
    verifyUrl: "https://engineer.kodekloud.com/certificate-verification/04ffb905-cd92-43af-91dc-60ac9cf8114d",
    badge: "https://certificates.engineer.kodekloud.com//689a9b3a8d56b2bb2e9d8f30/67f8c6419cda08d63b5ff8a0/04ffb905-cd92-43af-91dc-60ac9cf8114d.jpg",
  },
  {
    name: "100 Days of Cloud (Azure)",
    code: "",
    issuer: "KodeKloud",
    date: "Apr 2026",
    // credentialId: "8de5fb90-78d4-4598-945e-362b70f46ac2",
    verifyUrl: "https://engineer.kodekloud.com/certificate-verification/8de5fb90-78d4-4598-945e-362b70f46ac2",
    badge: "https://certificates.engineer.kodekloud.com//689a9b3a8d56b2bb2e9d8f30/691ac63502362aa9a9f60c78/8de5fb90-78d4-4598-945e-362b70f46ac2.jpg",
  },
  {
    name: "100 Days of Cloud (AWS)",
    code: "",
    issuer: "KodeKloud",
    date: "Feb 2026",
    // credentialId: "d642cc3d-431d-4f18-ae6a-f93747ff989b",
    verifyUrl: "https://engineer.kodekloud.com/certificate-verification/d642cc3d-431d-4f18-ae6a-f93747ff989b",
    badge: "https://certificates.engineer.kodekloud.com//689a9b3a8d56b2bb2e9d8f30/691ac6684aa4b86f475f7d17/d642cc3d-431d-4f18-ae6a-f93747ff989b.jpg",
  },
  {
    name: "Ansible for the Absolute Beginner - Hands-On - DevOps",
    code: "",
    issuer: "Udemy",
    date: "Dec 2025",
    // credentialId: "UC-0c33d411-1195-40c8-a0a9-1b4306a3a161",
    verifyUrl: "https://www.udemy.com/certificate/UC-0c33d411-1195-40c8-a0a9-1b4306a3a161/",
    badge: "https://udemy-certificate.s3.amazonaws.com/image/UC-0c33d411-1195-40c8-a0a9-1b4306a3a161.jpg?v=1765616445000",
  },
  {
    name: "Python for Beginners",
    code: "",
    issuer: "University of Moratuwa",
    date: "May 2025",
    credentialId: "XOtKQTjrpH",
    verifyUrl: "https://open.uom.lk/lms/mod/customcert/verify_certificate.php",
    badge: "",
  },
  {
    name: "Diploma in Information Technology",
    code: "",
    issuer: "University of Colombo School of Computing",
    date: "Apr 2021",
    credentialId: "201258",
    verifyUrl: "https://ucsc.cmb.ac.lk/verify",
    badge: "",
  },
  // Add more certifications here as you earn them, e.g.:
  // {
  //   name: "AWS Cloud Practitioner",
  //   code: "CLF-C02",
  //   issuer: "Amazon Web Services",
  //   date: "2026",
  //   credentialId: "",
  //   verifyUrl: "",
  //   badge: "https://...",
  // },
];

export const Certifications = () => {
  return (
    <section className="certifications" id="certifications">
      <div className="container">
        <div className="cert-shell">
          <div className="cert-heading">
            <span className="cert-kicker">Verified Credentials</span>
            <h2>Certifications &amp; Credentials</h2>
            <p>
              Industry-recognized certifications that validate my cloud
              computing, DevOps, and software engineering expertise.
            </p>
          </div>

          <div className="cert-grid">
            {certifications.map((cert, index) => (
              <div className="cert-card" key={index}>
                {/* Badge */}
                <div className="cert-badge">
                  {cert.badge ? (
                    <img src={cert.badge} alt={`${cert.name} badge`} />
                  ) : (
                    <span className="cert-badge-fallback">{cert.code}</span>
                  )}
                </div>

                {/* Info */}
                <div className="cert-info">
                  <span className="cert-name">{cert.name}</span>
                  <span className="cert-issuer">
                    {cert.issuer}
                    {cert.code && ` · ${cert.code}`}
                  </span>

                  <div className="cert-meta">
                    {cert.date && (
                      <span className="cert-date">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 16 16"
                          fill="currentColor"
                        >
                          <path d="M5.75 0a.75.75 0 0 1 .75.75V2h3V.75a.75.75 0 0 1 1.5 0V2H12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1V.75A.75.75 0 0 1 5.75 0ZM3.5 7v6a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V7h-9Z" />
                        </svg>
                        Issued {cert.date}
                      </span>
                    )}
                    {cert.credentialId && (
                      <span className="cert-id">
                        ID: {cert.credentialId}
                      </span>
                    )}
                  </div>

                  {cert.verifyUrl && (
                    <a
                      href={cert.verifyUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="cert-verify"
                    >
                      Verify
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                      >
                        <path d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                        <path d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};

